export default function createWidgetActions($http, $q, api, widgetPathName, actionTypes) {
    function getGraphEndpoint(graphType) {
        return `${api.restServiceUrlDB}${widgetPathName}/graph/${graphType}`;
    }
    const summaryEndpoint = `${api.restServiceUrlDB}${widgetPathName}/summary`;

    function getGraphData({ groupIds, environmentTypeIds, projectIds, start, end, graphType }) {
        return $http.post(`${getGraphEndpoint(graphType)}/${start}/${end}`, {
            projectIds,
            groupIds,
            environmentTypeIds
        }).then(response => response.data);
    }

    function getSummaries({ groupIds, environmentTypeIds, projectIds, start, end }) {
        return $http.post(`${summaryEndpoint}/${start}/${end}`, {
            projectIds,
            groupIds,
            environmentTypeIds
        }).then(response => response.data);
    }

    function loadSpecific({ environmentTypes,environmentTypesDeploy = [], projectIds, groupIds, timePeriod, graphType, start, end, summaryProjectIds = projectIds, summaryGroupIds = groupIds }, { graph = true, summary = true, setEnvironmentType = true }) {
        return dispatch => {
            let envTypesIds = environmentTypes.map(env => env.id);

            if (environmentTypesDeploy.length >0) {
                const selector = environmentTypes[0];
                if (selector.id == -1) {
                    envTypesIds = environmentTypesDeploy.splice(1).map(env => env.id);
                }
            }
            dispatch({ type: actionTypes.loadData.REQUEST, payload: {environmentType: environmentTypes[0], timePeriod }});
            const options = {
                environmentTypeIds: envTypesIds,
                projectIds, groupIds, graphType,
                start,
                end
            };

            const dataLoaders = [
                summary ? getSummaries({ ...options, projectIds: summaryProjectIds, groupIds: summaryGroupIds }) : false,
                graph ? getGraphData(options) : false
            ];
            return $q.all(dataLoaders).then(result => {
                const action = {
                    type: actionTypes.loadData.SUCCESS,
                    metadata: { graph, summary, setEnvironmentType },
                    payload: {
                        timePeriod,
                        environmentType: environmentTypes[0],
                        graphType,
                        timePeriodInfo: { start, end }
                    }
                };
                if (summary) {
                    action.payload.summaries = result[0];
                }
                if (graph) {
                    action.payload.data = result[1]
                }
                dispatch(action);
            }, error => {
                dispatch({ type: actionTypes.loadData.FAIL, error: true, payload: error.data });
            });
        };
    }

    function selectedSummaryChanged(index) {
        return { type: actionTypes.SUMMARY_SELECTED, payload: index };
    }

    function toggleLegendItem(item) {
        return { type: actionTypes.LEGEND_ITEM_TOGGLED, payload: item };
    }

    return { loadSpecific, selectedSummaryChanged, toggleLegendItem };
}



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/redux/create-widget-actions.js